<template>
  <div class="container" ref="assessmentEdit">
    <div class="uk-card uk-card-body" style="min-width: 85vw">
      <div class="uk-card-badge uk-label">{{assessment.type}}</div>
        <h3 class="uk-card-title"><input class="uk-input uk-form-blank" type="text" v-model="assessment.title" @change="updateAssessment()"/></h3>
        <p class="uk-text-left"><textarea rows="3" class="uk-textarea uk-form-blank" v-model="assessment.description" @change="updateAssessment()"/></p>
        <p class="uk-text-left"><label><input class="uk-checkbox" type="checkbox" v-model="assessment.isRandom" :value="assessment.isRandom" :checked="assessment.isRandom" @change="updateAssessment()"> Random questions</label></p>
        <p class="uk-text-left" v-if="assessment.type === 'Energy'"><label><input class="uk-checkbox" type="checkbox" v-model="assessment.isSortingByLevel" :value="assessment.isSortingByLevel" :checked="assessment.isSortingByLevel" @change="updateAssessment()"> Sorting by level</label></p>
        <p class="uk-text-center"><span v-if="message" class="uk-text-small uk-text-light" :class="message.type">{{message.text}}</span></p>
    </div>
    <h3 class="uk-heading-line uk-text-center"><span>List Questions</span></h3>
    <list-questions v-bind:parent-id="assessment._id" v-bind:type="assessment.type" v-bind:questions="assessment.questions"></list-questions>
  </div>
</template>

<script>
import ListQuestions from '@/components/ListQuestions'
import AssessmentService from '@/services/assessment.service';
export default {
  name: 'UpdateAssessment',
  components: {
    'list-questions': ListQuestions
  },
  created() {
    if(this.$route.params.id === undefined) {
       this.$router.push({name: "error404"});
    } else {
      this.getAssessment(this.$route.params.id);
    }
    setInterval(() => {
      this.message = null;
    }, 10000)
  },
  data() {
    return {
      assessment: {},
      message: ''
    }
  },
  methods: {
    getAssessment(id) {
       AssessmentService.one(id).then(
            res => {
              this.assessment = res.data;
              if(this.assessment.questions === undefined){
                this.assessment.questions = [];
              } else {
                this.assessment.questions = res.data.questions.map(obj=> ({ ...obj, isEdit: false }));
              }
              this.message = {text: res.data.message, type: 'uk-text-success'}
            },
            error => {
              let message = (error.response && error.response.data.message.message) || error.message || error.toString();
              this.message = {text: message, type: 'uk-text-danger'}
            }
          ) 
    },
    updateAssessment(){
      AssessmentService.update(this.assessment).then(
            res => {
              this.assessment.title = res.data.assessment.title;
              this.assessment.description = res.data.assessment.description;
              this.assessment.isRandom = res.data.assessment.isRandom
              this.assessment.isSortingByLevel = res.data.assessment.isSortingByLevel
              this.message = {text: res.data.message, type: 'uk-text-success'}
              
            },
            error => {
              let message = (error.response && error.response.data.message.message) || error.message || error.toString();
              this.message = {text: message, type: 'uk-text-danger'}
            }
          ) 
    }
  },

}
</script>

<style>

</style>